export const course = [
  {
    title: "Học lái xe B1",
    content: [
      "Ưu đãi: Giảm 500K khi đăng ký Online",
      "Đăng ký chỉ cần CMT",
      "Học phí trọn gói 100%",
      "Học 1 thầy 1 trò",
      "Học gần nhà, thời gian linh hoạt",
      "Thời gian đào tạo và thi: 2.5 tháng",
      "Đăng ký khóa B1 chỉ 10,5 triệu",
      "Có chương trình nâng cao",
      "(Cam kết KHÔNG phát sinh thêm chi phí)",
    ],
  },
  {
    title: "Học lái xe B2",
    content: [
      "Ưu đãi: Giảm 500K khi đăng ký Online",
      "Đăng ký chỉ cần CMT",
      "Học phí trọn gói 100%",
      "Học 1 thầy 1 trò",
      "Học gần nhà, thời gian linh hoạt",
      "Thời gian đào tạo và thi: 3 tháng",
      "Đăng ký khóa B2 chỉ 12.5 triệu",
      "Có chương trình nâng cao",
      "(Cam kết KHÔNG phát sinh thêm chi phí)",
    ],
  },
  {
    title: "Học lái xe C",
    content: [
      "Ưu đãi: Giảm 500K khi đăng ký Online",
      "Đăng ký chỉ cần CMT",
      "Học phí trọn gói 100%",
      "Học 1 thầy 1 trò",
      "Học gần nhà, thời gian linh hoạt",
      "Thời gian đào tạo và thi: 5 tháng",
      "Đăng ký khóa C chỉ 16.5 triệu",
      "Có chương trình nâng cao",
      "(Cam kết KHÔNG phát sinh thêm chi phí)",
    ],
  },
  {
    title: "NÂNG HẠNG D – E",
    subTitle: "HỌC PHÍ ƯU ĐÃI",
    content: [
      "Nâng B2 lên C; Nâng B2 lên D",
      "Nâng C lên D; Nâng C lên E",
      "Học phí trọn gói 100%",
      "Miễn phí tài liệu ôn tập",
      "Đăng ký – Vào khóa ngay",
      "Nhận bằng 1 tuần sau khi thi",
      "Hỗ trợ làm hồ sơ tại nhà",
      "(Cam kết KHÔNG phát sinh thêm chi phí)",
    ],
  },
  {
    title: "GIA HẠN GPLX",
    subTitle: "MIỄN PHÍ THỦ TỤC",
    content: [
      "Gọi 0927484848",
      "Miễn phí tư vấn và thủ tục",
      "Các trường hợp quá hạn GPLX:",
      "Đổi cũ sang mới: Cấp đổi thông thường",
      "Dưới 3 tháng: Cấp đổi thông thường",
      "Từ 3 tháng đến 1 năm: Thi lại lý thuyết",
      "Ngoài 1 năm: Học viên thi lại lý thuyết và thực hành",
    ],
  },
];
